import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';
import { decodeJwtPayload } from '@/lib/jwtPayload';

export function useCalendarPermissions(): string[] {
  const accessToken = useSelector((s: RootState) => s.auth.accessToken);
  return useMemo(() => {
    const payload = decodeJwtPayload(accessToken);
    const raw = payload?.calendarPermissions;
    return Array.isArray(raw) ? (raw.filter((x) => typeof x === 'string') as string[]) : [];
  }, [accessToken]);
}
